import React from 'react';
import { Typography } from '@mui/material';
import {
  formatTimeslotRangeKo,
  formatTimeslotRangeKoParts,
  type Timeslot,
} from '@/shared/lib/timeslot/timeslot.types';
import { fontSize, typography } from '@/shared/theme';

interface TimeslotDiffProps {
  from: string;
  to: string;
}

/**
 * 두 timeslot의 변경을 표시합니다.
 * 날짜가 같을 경우 두 번째는 시간만 표시하여 축약합니다.
 * 예: "2026년 2월 16일 17시 - 18시 → 14시 30분 - 15시 30분"
 */
export function TimeslotDiff({ from, to }: TimeslotDiffProps) {
  const fromParts = formatTimeslotRangeKoParts(from as Timeslot);
  const toParts = formatTimeslotRangeKoParts(to as Timeslot);

  let fromDisplay: string;
  let toDisplay: string;

  if (fromParts && toParts) {
    fromDisplay = `${fromParts.date} ${fromParts.timeRange}`;
    // 날짜가 같으면 두 번째는 시간만 표시
    toDisplay =
      fromParts.date === toParts.date ? toParts.timeRange : `${toParts.date} ${toParts.timeRange}`;
  } else {
    fromDisplay = fromParts
      ? `${fromParts.date} ${fromParts.timeRange}`
      : (() => {
          try {
            return formatTimeslotRangeKo(from as Timeslot);
          } catch {
            return from;
          }
        })();
    toDisplay = toParts
      ? `${toParts.date} ${toParts.timeRange}`
      : (() => {
          try {
            return formatTimeslotRangeKo(to as Timeslot);
          } catch {
            return to;
          }
        })();
  }

  return (
    <Typography
      component="span"
      sx={{
        fontSize: fontSize.sm,
        fontWeight: typography.cell.fontWeight,
        color: 'text.primary',
      }}
    >
      {fromDisplay} → {toDisplay}
    </Typography>
  );
}
